/**
 * Dynamic Routed Form Handler
 * Supports multiple forms per page.
 * Upload to: Assets > contact-form-routed.js
 */
(function () {
  function initForm(form) {
    var btn = form.querySelector('[type="submit"]');
    var status = form.querySelector('[class*="__status"]');
    var btnText = btn.querySelector('.contact-routed__btn-text');
    var btnLoad = btn.querySelector('.contact-routed__btn-loading');

    form.addEventListener('submit', function (e) {
      e.preventDefault();

      /* Honeypot — clear autofill before checking */
      var hp = form.querySelector('[name="company_url"]');
      if (hp) hp.value = '';

/* Age check (must be 21+) */
var birthdayInput = form.querySelector('[name="Birthday"]');
if (birthdayInput && birthdayInput.value) {
  var birthDate = new Date(birthdayInput.value);
  var today = new Date();
  var age = today.getFullYear() - birthDate.getFullYear();
  var monthDiff = today.getMonth() - birthDate.getMonth();
  if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  if (age < 21) {
    var fieldWrap = birthdayInput.closest('.contact-routed__field');
    var existingErr = fieldWrap.querySelector('.contact-routed__field-error');
    if (!existingErr) {
      var errEl = document.createElement('p');
      errEl.className = 'contact-routed__field-error';
      errEl.textContent = 'You must be 21 or older to apply.';
      fieldWrap.appendChild(errEl);
    }
    birthdayInput.style.borderColor = '#c0392b';
    return;
  }
}

      /* File size check (20MB) */
      var fileInputs = form.querySelectorAll('input[type="file"]');
      for (var i = 0; i < fileInputs.length; i++) {
        if (fileInputs[i].files.length > 0 && fileInputs[i].files[0].size > 20 * 1024 * 1024) {
          status.className = 'contact-routed__status contact-routed__status--error';
          status.textContent = 'File is too large. Maximum size is 20MB.';
          status.hidden = false;
          return;
        }
      }

      btn.disabled = true;
      btnText.hidden = true;
      btnLoad.hidden = false;
      status.hidden = true;

      /* Build FormData */
      var formData = new FormData(form);
      formData.delete('company_url');

      /* Add context */
      formData.append('shop', window.Shopify ? Shopify.shop : location.hostname);
      formData.append('page_url', location.href);
      formData.append('submitted_at', new Date().toISOString());

      /* Add routing info */
      formData.append('route_field', form.dataset.routeField || '');

      fetch(form.action, {
        method: 'POST',
        body: formData,
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Server responded with ' + res.status);
          return res.json();
        })
        .then(function () {
          var msg = form.closest('.contact-routed');
          var successText = 'Thanks! We\'ll be in touch soon.';

          /* Try to get custom success message from section settings */
          if (msg) {
            var customMsg = msg.querySelector('[data-success-message]');
            if (customMsg) successText = customMsg.dataset.successMessage;
          }

          status.className = 'contact-routed__status contact-routed__status--success';
          status.textContent = successText;
          status.hidden = false;
          form.reset();
        })
        .catch(function () {
          status.className = 'contact-routed__status contact-routed__status--error';
          status.textContent = 'Something went wrong. Please try again or email us directly.';
          status.hidden = false;
        })
        .finally(function () {
          btn.disabled = false;
          btnText.hidden = false;
          btnLoad.hidden = true;
        });
    });

    console.log('[ContactFormRouted] Handler attached to', form.id || 'form');
  }

  function init() {
    var forms = document.querySelectorAll('.js-routed-form');
    for (var i = 0; i < forms.length; i++) {
      initForm(forms[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
